import React, { useId } from "react";

type TooltipPosition = "top" | "bottom" | "left" | "right";

interface TooltipIconButtonProps {
  tooltip: string;
  position?: TooltipPosition;
  icon: React.ReactNode;
  onClick?: () => void;
}

const positionStyles: Record<TooltipPosition, string> = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2",
};

export default function TooltipIconButton({
  tooltip,
  position = "top",
  icon,
  onClick,
}: TooltipIconButtonProps) {
  const id = useId();

  return (
    <div className="relative inline-flex group">
      <button
        onClick={onClick}
        aria-describedby={id}
        aria-label={tooltip}
        className="inline-flex h-9 w-9 items-center justify-center rounded-md hover:bg-gray-100 focus:outline-none"
      >
        {icon}
      </button>

      <div
        id={id}
        role="tooltip"
        className={`
          pointer-events-none
          absolute z-50
          whitespace-nowrap
          rounded-md
          bg-gray-900
          px-2.5 py-1.5
          text-xs text-white
          opacity-0 invisible
          transition-all duration-200
          group-hover:visible group-hover:opacity-100
          group-focus-within:visible group-focus-within:opacity-100
          ${positionStyles[position]}
        `}
      >
        {tooltip}
      </div>
    </div>
  );
}
